import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';
import { AuthGuard, FeatureGuard } from '@ta/user';

export enum ERecommendationsRoute {
  recommendations = 'recommendations',
  searches = 'searches',
  searchNew = 'searchNew',
  searchEdit = 'searchEdit',
  estateSearch = 'estateSearch',
}

TaRoutes.addRoute({
  key: ERecommendationsRoute.recommendations,
  url: 'recommendations',
  children: [
    { key: ERecommendationsRoute.searches, url: 'searches' },
    { key: ERecommendationsRoute.searchNew, url: 'searches/new' },
    { key: ERecommendationsRoute.searchEdit, url: 'searches/:id/edit' },
    { key: ERecommendationsRoute.estateSearch, url: 'search' },
  ],
});

// Réservé aux locataires : la feature `tenant` est posée dans `UserService` (convention FeatureGuard).
const guarded = {
  canActivate: [AuthGuard, FeatureGuard],
  data: { feature: 'tenant', level: 'authorize' },
};

export const recommendationsRoutes: Routes = [
  {
    path: '',
    title: 'app.pages.recommendations.title',
    loadComponent: () => import('./pages/for-you/for-you').then((c) => c.ForYouPage),
    ...guarded,
  },
  {
    path: TaRoutes.getUrl([ERecommendationsRoute.recommendations, ERecommendationsRoute.searches]),
    title: 'app.pages.my_searches.title',
    loadComponent: () => import('./pages/my-searches/my-searches').then((c) => c.MySearchesPage),
    ...guarded,
  },
  {
    path: TaRoutes.getUrl([
      ERecommendationsRoute.recommendations,
      ERecommendationsRoute.estateSearch,
    ]),
    title: 'app.pages.estate_search.title',
    loadComponent: () =>
      import('./pages/estate-search/estate-search').then((c) => c.EstateSearchPage),
    ...guarded,
  },
  {
    // `new` avant la route paramétrée.
    path: TaRoutes.getUrl([ERecommendationsRoute.recommendations, ERecommendationsRoute.searchNew]),
    title: 'app.pages.search_form.title',
    loadComponent: () => import('./pages/search-form/search-form').then((c) => c.SearchFormPage),
    ...guarded,
  },
  {
    path: TaRoutes.getUrl([
      ERecommendationsRoute.recommendations,
      ERecommendationsRoute.searchEdit,
    ]),
    title: 'app.pages.search_form.title',
    loadComponent: () => import('./pages/search-form/search-form').then((c) => c.SearchFormPage),
    ...guarded,
  },
];
